import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAddressByCep = createAsyncThunk(
  "address/fetchAddressByCep",
  async (cep: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      if (response.data.erro) {
        return rejectWithValue("CEP inválido");
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erro ao buscar o CEP");
    }
  },
);
